import React from 'react';
import __ from "../../../i18n";
import InlineEditButton from "../components/inline-edit-button/InlineEditButton";
import ImageHelper from "../../../helpers/ImageHelper";
import visibilities from "../../../model-constants/article/visibilities";


function getColumnConfigs({updateItem, refreshData, refs}) {
    return [
        {
            key: 'id',
            name: __('ID'),
            sortable: true
        },
        {
            key: 'avatar_image_id',
            name: __('Avatar image'),
            renderValue: (value) => {
                const image = refs.images.find(t => t.id === value);

                return <img src={ImageHelper.getUrl(image)} alt={image.title}/>;
            }
        },
        {
            key: 'name',
            name: __('Name'),
            sortable: true,
            renderValue: (value, item) => {
                return <>
                    <p>{value}</p>
                    <p>
                        <InlineEditButton
                            item={item}
                            onDone={(values) => refreshData()}
                        />
                    </p>
                </>;
            }
        },
        {
            key: 'visibility',
            name: __('Visibility'),
            sortable: true,
            renderValue: value => visibilities.get(value).label
        },
        {
            key: 'priority',
            name: __('Priority'),
            sortable: true,
            renderValue: value => __('::number', {number: value})
        },
    ];
}

export default {
    getColumnConfigs
};
